import React from 'react';
import styled from 'styled-components';

import {colorTheme} from '../../../mixin/colorTheme';
import {FormLabel} from '../../form-features/labels/FormLabel';
import {ToggleBackground, ToggleHandle} from './ToggleFeatures';
import {toggleDirection, toggleFeatureSetup, toggleSize} from './toggleSetup';

/**
 * @param {object} param0
 * @param {string} param0.label
 * @param {boolean} param0.checked
 * @param {import('react').ChangeEventHandler<HTMLInputElement>} param0.onChange
 * @param {string} param0.name
 * @param {'size'} [param0.size]
 * @param {'right'} [param0.direction]
 * @returns {import('react').ReactElement}
 */
const Toggle = ({label, checked, onChange, name, size, direction, ...props}) => (
    <ToggleContainer checked={checked} direction={direction} size={size}>
        <input type="checkbox" id={name + 'Toggle'} name={name} checked={checked} onChange={onChange} {...props} />
        <ToggleBackground size={size}>
            <ToggleHandle />
        </ToggleBackground>
        <FormLabel size={size} htmlFor={name + 'Toggle'}>
            {label}
        </FormLabel>
    </ToggleContainer>
);

const ToggleContainer = styled.label`
    --toggle-width: 44px;
    --toggle-height: 20px;
    --toggle-handle: 16px;
    --toggle-handle-position: 3px;

    ${colorTheme({
        '--toggle-handle-bg       ': {dark: 'var(--gray-08)      ', light: 'var(--gray-00)'},
        '--toggle-container-bg    ': {dark: 'var(--black-04)      ', light: 'var(--gray-02)'},
    })};

    ${({checked}) => {
        if (checked)
            return `
        ${ToggleHandle} {
            background: var(--white-00);
        }
        `;
        else return;
    }}
    ${ToggleBackground} {
        width: var(--toggle-width);
        height: var(--toggle-height);
        ${ToggleHandle} {
            width: var(--toggle-handle);
            height: var(--toggle-handle);
        }
    }
    ${toggleFeatureSetup};
    ${({direction}) => toggleDirection(direction)};
    ${({size}) => toggleSize(size)};
`;

Toggle.Wrapper = ToggleContainer;
export {Toggle, ToggleContainer};
